/* unplugin-vue-components disabled */import { render } from "./FloatMenu.vue?vue&type=template&id=138d2da8"
import script from "./FloatMenu.vue?vue&type=script&lang=js"
export * from "./FloatMenu.vue?vue&type=script&lang=js"

import "./FloatMenu.vue?vue&type=style&index=0&id=138d2da8&lang=css"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__